import { Button, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";

export type PreisType = {
  leistung: string;
  beschreibung: string;
  preise: string[];
  dauer?: string;
  link?: string;
};

export default function PreisBox(props: { preis: PreisType }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const openLink = () => navigate("/leistungen/" + props.preis.link);
  return (
    <div
      className="preis-box"
      style={{
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.secondary.main,
      }}
    >
      <div className="preis-content">
        <Typography variant="h4" component="h2" textAlign="center" onClick={openLink}>
          {props.preis.leistung}
        </Typography>
        <Typography
          variant="body1"
          textAlign="center"
          className="description padding"
          onClick={openLink}
        >
          {props.preis.beschreibung}
        </Typography>
        {props.preis.dauer && (
          <Typography
            variant="body1"
            textAlign="center"
            fontWeight="bold"
            className="padding"
            onClick={openLink}
          >
            {props.preis.dauer}
          </Typography>
        )}

        {props.preis.preise.map((preis) => (
          <Typography
            variant="body1"
            textAlign="center"
            fontWeight="bold"
            className="padding"
            onClick={openLink}
            key={preis}
          >
            {preis}
          </Typography>
        ))}
        {props.preis.link && (
          <Button
            sx={{ textTransform: "none" }}
            variant="contained"
            onClick={() =>
              navigate(
                "/kontakt?betreff=Terminanfrage+" +
                  props.preis.leistung.replace(" ", "+")
              )
            }
          >
            Termin vereinbaren
          </Button>
        )}
      </div>
    </div>
  );
}
